// extracted by mini-css-extract-plugin
module.exports = {"container":"WhoWeAre_container__I7KKt","image":"WhoWeAre_image__hs6Dn","wrapper":"WhoWeAre_wrapper__YH2dt","header_cta":"WhoWeAre_header_cta__OgODn"};